<template>
  <div class="form-group">
    <w-terc-picker
      :model="model"
      :url="url"
      :emptyListMsg="emptyListMsg"
      :showError="showError"
      @selectedWoj="(val) => $emit('selectedWoj', val)"
      @selectedPow="(val) => $emit('selectedPow', val)"
      @selectedGmi="(val) => $emit('selectedGmi', val)"
    />

    <w-simc-picker
      :model="model"
      :url="url"
      :terc="terc"
      :emptyListMsg="emptyListMsg"
      :showError="showError"
      @selectedCity="(val) => $emit('selectedCity', val)"
    />

    <w-ulic-picker
      :model="model"
      :url="url"
      :terc="terc"
      :simc="simc"
      :placeholder="cityPlaceholder"
      :emptyListMsg="emptyListMsg"
      :showError="showError"
      @selectedStreet="(val) => $emit('selectedStreet', val)"
    />
  </div>
</template>

<script>
import WTercPicker from './tercPicker.vue';
import WSimcPicker from './simcPicker.vue';
import WUlicPicker from './ulicPicker.vue';

// @vuese
// Input na TERYT-a
// @group Components
export default {
  name: 'w-teryt-picker',
  components: {WTercPicker, WSimcPicker, WUlicPicker},
  props: {
    // URL do TERYT API
    url: {
      type: String,
      required: true
    },
    // Schema
    model: {
      type: Object,
      required: true
    },
    // Wartość TERC-a
    terc: {
      type: String,
      required: true
    },
    // Wartość SIMC-a
    simc: {
      type: String,
      required: true
    },
    // Placeholder dla ulic
    cityPlaceholder: {
      type: String,
      required: false,
      default: ''
    },
    // Tekst do wyświetlenia w przypadku pustej listy
    emptyListMsg: {
      type: String,
      required: false,
      default: ''
    },
    // Czy pokazywać błędy
    showError: {
      type: Boolean,
      default: true
    }
  }
};
</script>
